import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, DialogActions, Button } from "@mui/material";
import { Close } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import "./CommonDialog.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": {
		padding: theme.spacing(2),
	},
	"& .MuiDialogActions-root": {
		padding: theme.spacing(1),
	},
}));

const CommonDialog = (props) => {
	const {
		maxWidth = "md",
		open,
		onClose,
		children,
		title = "",
		childrenFooter,
		onSave,
		disabledSave,
		customDialogContent = false,
		titleClassName = "",
	} = props;
	return (
		<BootstrapDialog
			open={open}
			fullWidth={true}
			maxWidth={maxWidth}
			aria-labelledby="form-dialog-title"
			className="common-dialog"
		>
			<DialogTitle sx={{ m: 0, p: 2 }} className={titleClassName}>
				{title}
			</DialogTitle>
			<IconButton
				aria-label="close"
				onClick={onClose}
				sx={(theme) => ({
					position: "absolute",
					right: 8,
					top: 8,
					color: theme.palette.grey[500],
				})}
			>
				<Close />
			</IconButton>
			{customDialogContent ? (
				children
			) : (
				<React.Fragment>
					<DialogContent className="edit-user-dialog">{children}</DialogContent>
					<DialogActions className="form-dialog-footer">
						<Button
							variant="contained"
							color="primary"
							size="small"
							type="submit"
							onClick={onSave}
							disabled={disabledSave}
						>
							Save
						</Button>
						<Button variant="contained" size="small" onClick={onClose}>
							Cancel
						</Button>
						{childrenFooter || null}
					</DialogActions>
				</React.Fragment>
			)}
		</BootstrapDialog>
	);
};

export default CommonDialog;
